import { Middleware } from "@reduxjs/toolkit";
import { DeviceType } from "../../../types";
import { STORAGE_KEY_BY_DEVICE_TYPE } from "../../../constants";
import {
  setActiveAudioInput,
  setActiveAudioOutput,
  setActiveVideoInput,
} from "../../slice";
import { toSerialized } from "../utils";

export const SYNCHRONIZATION_TO_STORAGE_TRIGGERS = [
  setActiveAudioInput.toString(),
  setActiveAudioOutput.toString(),
  setActiveVideoInput.toString(),
];

type TriggeringActions =
  | ReturnType<typeof setActiveAudioInput>
  | ReturnType<typeof setActiveAudioOutput>
  | ReturnType<typeof setActiveVideoInput>;

export const DEVICE_TYPE_BY_ACTION_TYPE: Record<string, DeviceType> = {
  [setActiveAudioInput.toString()]: "audioInput",
  [setActiveAudioOutput.toString()]: "audioOutput",
  [setActiveVideoInput.toString()]: "videoInput",
};

export const synchronizeSelectedDevicesToStorageMiddleware: Middleware =
  () => (next) => (action: TriggeringActions) => {
    next(action);

    if (!SYNCHRONIZATION_TO_STORAGE_TRIGGERS.includes(action.type)) {
      return;
    }

    const deviceType = DEVICE_TYPE_BY_ACTION_TYPE[action.type];
    const storageKey = STORAGE_KEY_BY_DEVICE_TYPE[deviceType];

    localStorage.setItem(
      storageKey,
      JSON.stringify(toSerialized(action.payload)),
    );
  };
